module.exports = __webpack_public_path__ + "img/6683666.jpg";